import { normalizePairingCode } from '@forgesworn/joystick-protocol';
import type { PairingToken } from '@forgesworn/joystick-mobile';

export const DEFAULT_WS = 'wss://controller.pallasite.app/';
const SESSION_RE = /^[a-z0-9_-]{4,128}$/i;

/** Keep the complete token when scanning or pasting a self-hosted game URL. */
export function parsePairingInput(raw: string): PairingToken | null {
  const trimmed = raw.trim();
  try {
    const url = new URL(trimmed);
    if (!['http:', 'https:', 'joystick:'].includes(url.protocol) || url.username || url.password
      || url.searchParams.getAll('s').length !== 1 || url.searchParams.getAll('v').length > 1 || url.searchParams.getAll('w').length > 1) return null;
    const sessionId = url.searchParams.get('s');
    const ws = url.searchParams.get('w') ?? DEFAULT_WS;
    if (!sessionId || !SESSION_RE.test(sessionId)) return null;
    const endpoint = new URL(ws);
    if (!['ws:', 'wss:'].includes(endpoint.protocol) || !endpoint.hostname || endpoint.username || endpoint.password || endpoint.search || endpoint.hash) return null;
    const version = url.searchParams.get('v');
    if (version !== null && version !== '2' || version === '2' && sessionId.length < 6) return null;
    return { sessionId, ws, ...(version === '2' ? { version: 2 } : {}) };
  } catch {
    // Bare codes use the uppercase alphabet generated by the host SDK.
    const sessionId = normalizePairingCode(trimmed);
    return SESSION_RE.test(sessionId) && sessionId.length !== 5 ? { sessionId, ws: DEFAULT_WS, ...(sessionId.length === 4 ? {} : { version: 2 as const }) } : null;
  }
}

export function pairingPath(token: PairingToken): string {
  const params = new URLSearchParams({ s: token.sessionId });
  if (token.ws !== DEFAULT_WS) params.set('w', token.ws);
  if (token.version === 2) params.set('v', '2');
  return `/?${params.toString()}`;
}
